export const formatTimeToMinSecMilli = (timeString: string) => {
  if (timeString === '00:00:00') return timeString;
  return timeString.slice(-13, -4);
};
